import { useEffect, useRef } from 'react';

export const useValueChanges = <TValue>(
  callback: (current?: TValue, prev?: TValue) => void,
  value?: TValue,
) => {
  const prevValue = useRef<TValue | undefined>(value);

  useEffect(() => {
    if (prevValue.current !== value && typeof prevValue.current !== 'undefined') {
      callback(value, prevValue.current);
    }

    prevValue.current = value;
  }, [value, callback]);
};
